import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import { useOrganization } from '@/pages/organizations/detail'
import CalculatorPage from '@/pages/organizations/detail/sets/detail/calculator'
import { find } from 'lodash'

export const Route = createFileRoute('/app/organizations/$organizationId/sets/$setId/calculator')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { setId } = Route.useParams()
  const { organization, assessments } = useOrganization()

  const assessment = find(assessments, (_a) => Number(_a.id) === Number(setId))

  if (!assessment) return null

  return <CalculatorPage organization={organization} assessment={assessment} />
}
